import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { Quality } from '../models';
import { BaseEditService } from './base';

@Injectable({
  providedIn: 'root',
})
export class QualityService extends BaseEditService<Quality, Quality> {
  readonly qualitySelected$ = new Subject<string>();

  constructor() {
    super('Quality', $localize`Quality`);
  }
}
